import moment from "moment-timezone";
import Axios from "axios";
import { getApiDomain } from "../agent/config";
import { getItem } from "../utils/storage";
import getV2AxiosInstance from "../utils/v2Axios.js";

export function closeMenuPopup() {
  return (dispatch) => {
    return dispatch({
      type: "CLOSE_MENU_POPUP",
      payload: moment().unix(),
    });
  };
}

export function getCustomLogo() {
  return (dispatch) => {
    getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Client", {
        action: "getConfiguration",
        params: { agent_id: localStorage.getItem("agent_id") },
      })
      .then((response) => {
        if (
          response.data.result &&
          response.data.response &&
          response.data.response.items &&
          response.data.response.items.length
        ) {
          const item = response.data.response.items[0];
          return dispatch({
            type: "SET_LOGO",
            payload: (item.data && item.data.logo) || "",
          });
        }
      });
  };
}

export function getOmniUrl() {
  return (dispatch) => {
    getV2AxiosInstance()
      .post("api/en/invoxapi/chatwoot?action=geturl&domain=invoxcontact.io&environment=prod", {
        actiondata: {
          agentid: localStorage.getItem("clientId") + "-" + localStorage.getItem("extension"),
        },
      })
      .then((response) => {
        if (
          response.data.result &&
          response.data.response &&
          response.data.response.items &&
          response.data.response.items.length
        ) {
          const item = response.data.response.items[0];
          return dispatch({
            type: "set_omnidata",
            payload: item || null,
          });
        }
      });
  };
}

export const set_showRecording = (value) => {
  return {
    type: "set_showRecording",
    payload: value,
  };
};

export const set_thememode = (value) => {
  return {
    type: "set_thememode",
    payload: value,
  };
};

export const set_theme = (value) => {
  return {
    type: "set_theme",
    payload: value,
  };
};

export const get_theme = (value) => {
  return {
    type: "get_theme",
    payload: value,
  };
};

export function setAudioSettings(data){
  return {
    type: "settings_audio",
    payload: data,
  }
}

export const set_themecode = (value) => {
  return {
    type: "set_themecode",
    payload: value,
  };
};

export const get_themevalue = (value) => {
  return {
    type: "get_themevalue",
    payload: value,
  };
};

export const set_userInteraction = (value) => {
  return {
    type: "set_userInteraction",
    payload: value,
  };
};

export const set_showInvalidAudioSettingsMessage = (value) => {
  return {
    type: "set_showInvalidAudioSettingsMessage",
    payload: value,
  };
};


// WEBPACK FOOTER //
// ./src/actions/common.js